@if (isOpen()) {
  <div
    #menuContainer
    class="action-menu"
    role="menu"
    [attr.aria-label]="'Action menu'">
    @for (item of items(); track item.id; let i = $index) {
      <div
        class="action-menu__item"
        [class.action-menu__item--hovered]="isItemHovered(i)"
        (mousedown)="$event.preventDefault(); selectAction(item)"
        (mouseenter)="onItemMouseEnter(i)"
        (mouseleave)="onItemMouseLeave()"
        role="menuitem"
        tabindex="0">
        <span class="action-menu__item-label">{{ item.label | translateLang }}</span>
      </div>
    }
  </div>
}
